import Status from "../../../../components/Status";
import Button from "../../../../components/Button";
import styles from "../css/expiredStock.module.css";

// Helper to format tooltip based on days until expiry
export const expiryTooltip = (row) => {
  if (!row) return undefined;
  const days = typeof row.daysUntilExpiry === "number" ? row.daysUntilExpiry : null;
  const p = (row.priority || "").toString().toLowerCase();

  if (p === "expired" || (days != null && days < 0)) {
    return "Expired";
  }

  if (days == null) return undefined;
  if (days === 0) return "Expires today";
  if (days === 1) return "Expires in 1 day";
  return `Expires in ${days} days`;
};

export const statusColor = (prio) => {
  const p = (prio || '').toString().toLowerCase();
  if (p === 'expired') return '#ef4444';
  if (p === 'high') return '#991b1b';
  if (p === 'moderate') return '#c2410c';
  if (p === 'low') return '#166534';
  return '#6b46c1';
};

// Base columns for Dispensary/Clinic
export const baseColumns = [
  { header: "Drug Name", accessor: "drugName" },
  { header: "NAPPI Code", accessor: "nappi" },
  { header: "Category", accessor: "category" },
  { header: "Qty", accessor: "qty" },
  { header: "Expiry Date", accessor: "expiry" },
  {
    header: "Priority",
    accessor: "priority",
    render: (value, row) => (
      <Status status={value} variant="priority" tooltip={expiryTooltip(row)} enableHover />
    ),
  },
  { header: "Storage", accessor: "storage" },
  {
    header: "Action",
    accessor: "action",
    render: (_, row) => (
      <Button
        variant="primary"
        className={styles.viewBtn}
        onClick={() => {
          // This will be handled by parent component
          if (window.handleViewMoreClick) {
            window.handleViewMoreClick(row);
          }
        }}
      >
        View More
      </Button>
    ),
  },
];

// Columns for OTC/Clinic view
export const otcColumns = [
  { header: "Product Name", accessor: "drugName" },
  { header: "NAPPI Code", accessor: "nappi" },
  { header: "Barcode", accessor: "barcode" },
  { header: "Category", accessor: "category" },
  { header: "Qty", accessor: "qty" },
  { header: "Expiry Date", accessor: "expiry" },
  {
    header: "Priority",
    accessor: "priority",
    render: (value, row) => (
      <Status status={value} variant="priority" tooltip={expiryTooltip(row)} enableHover />
    ),
  },
  { header: "Storage", accessor: "storage" },
  {
    header: "Action",
    accessor: "action",
    render: (_, row) => (
      <Button
        variant="primary"
        className={styles.viewBtn}
        onClick={() => {
          // This will be handled by parent component
          if (window.handleViewMoreClick) {
            window.handleViewMoreClick(row);
          }
        }}
      >
        View More
      </Button>
    ),
  },
];

// Columns for Front Shop view per screenshot
export const frontShopColumns = [
  { header: "Product Name", accessor: "drugName" },
  { header: "Barcode", accessor: "barcode" },
  { header: "Qty", accessor: "qty" },
  { header: "Expiry Date", accessor: "expiry" },
  {
    header: "Priority",
    accessor: "priority",
    render: (value, row) => (
      <Status status={value} variant="priority" tooltip={expiryTooltip(row)} enableHover />
    ),
  },
  { header: "Storage", accessor: "storage" },
  { header: "Category", accessor: "category" },
  {
    header: "Action",
    accessor: "action",
    render: (_, row) => (
      <Button
        variant="primary"
        className={styles.viewBtn}
        onClick={() => {
          // This will be handled by parent component
          if (window.handleViewMoreClick) {
            window.handleViewMoreClick(row);
          }
        }}
      >
        View More
      </Button>
    ),
  },
];

// Columns for Clinic view per screenshot (Item Name instead of Product Name)
export const clinicColumns = [
  { header: "Item Name", accessor: "drugName" },
  { header: "Qty", accessor: "qty" },
  { header: "Expiry Date", accessor: "expiry" },
  {
    header: "Priority",
    accessor: "priority",
    render: (value, row) => (
      <Status status={value} variant="priority" tooltip={expiryTooltip(row)} enableHover />
    ),
  },
  { header: "Shelve Number", accessor: "storage" },
  { header: "Category", accessor: "category" },
  {
    header: "Action",
    accessor: "action",
    render: (_, row) => (
      <Button
        variant="primary"
        className={styles.viewBtn}
        onClick={() => {
          // This will be handled by parent component
          if (window.handleViewMoreClick) {
            window.handleViewMoreClick(row);
          }
        }}
      >
        View More
      </Button>
    ),
  },
];

export const getColumnsForSegment = (activeSegment) => {
  if (activeSegment === "Front Shop") return frontShopColumns;
  if (activeSegment === "Clinic" || activeSegment === "OTC") return otcColumns;
  return baseColumns;
};
